import styled from 'styled-components';

import chevronRightBlack from '../../../images/common/chevron-right-black.svg';

export const MainStyled = styled.div`
  margin-top: 180px;
  @media (min-width: 310px) {
    margin-top: 160px;
  }
  @media (min-width: 385px) {
    margin-top: 140px;
  }
  @media (min-width: 660px) {
    margin-top: 112px;
  }
  .container {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 0;
    @media (min-width: 992px) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 50px;
    }
  }
`;

export const PreTitle = styled.div`
  color: var(--gray);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-transform: uppercase;
  width: auto;
  @media (min-width: 992px) {
    width: 100%;
  }
`;

export const Title = styled.div<{ case: string | undefined }>`
  color: var(--black);
  font-family: Rubik;
  font-size: 48px;
  font-weight: bold;
  letter-spacing: -1px;
  line-height: 56px;
  @media (min-width: 992px) {
    font-size: 64px;
    line-height: 72px;
    width: ${(props) =>
      props.case === '2' || props.case === '4' ? '647px' : '455px'};
  }
`;

export const Subtitle = styled.p`
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 21px;
  strong {
    font-weight: bold;
  }
  @media (min-width: 992px) {
    font-size: 16px;
    line-height: 32px;
    margin-top: 37px;
    max-width: 455px;
  }
`;

export const ButtonContainer = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  max-width: 354px;
  margin-top: 54px;
  @media (min-width: 992px) {
    display: flex;
  }
`;

export const NextCaseBtn = styled.span`
  display: flex;
  align-items: center;
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  img {
    margin-left: 16.5px;
    &:last-of-type {
      display: none;
    }
  }
  &:hover {
    color: var(--lblue);
    img {
      &:first-of-type {
        display: none;
      }
      &:last-of-type {
        display: inline;
      }
    }
  }
`;

export const Btn = styled.span`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  width: 152px;
  border: 1px solid var(--blue);
  border-radius: 32px;
  outline: var(--blue);
  cursor: pointer;
  font-family: Rubik;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  color: var(--blue);
  margin-right: 40px;
  &:hover {
    background: var(--blue);
    color: var(--white);
  }
`;

export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  z-index: 1;
  width: 100%;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    > img {
      display: none;
    }
    @media (min-width: 992px) {
      width: 455px;
      > img {
        display: inline;
      }
      ${NextCaseBtn} {
        display: none;
      }
    }
  }
  @media (min-width: 992px) {
    width: 455px;
    margin-right: 24px;
  }
`;

export const Card = styled.div`
  box-sizing: border-box;
  padding: 25px;
  height: 144px;
  width: 264px;
  color: var(--white);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  border-radius: 20px;
  background: var(--blue);
  outline: none;
  strong {
    font-weight: bold;
  }
  @media (min-width: 992px) {
    min-height: 96px;
    height: auto;
    max-height: 120px;
    width: 360px;
    &:not(:last-of-type) {
      margin-bottom: 24px;
    }
  }
`;

export const CardsContainer = styled.div`
  display: none;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  position: absolute;
  top: 50;
  right: 0;
  @media (min-width: 992px) {
    display: flex;
  }
`;

export const PaginationPill = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--lgray);
  height: 56px;
  width: 149px;
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  padding: 4px;
  border-radius: 32px;
  margin-top: 48px;
  margin-left: 20px;
`;

export const SliderContainer = styled.div`
  margin-top: 50px;
  margin-bottom: 80px;
  .slick-slider {
    .slick-list {
      .slick-track {
        padding: 0 20px;
        .slick-slide {
          &:not(:last-of-type) {
            > div {
              margin-right: 24px;
            }
          }
        }
      }
    }
    .slick-arrow {
      top: unset;
      bottom: -86px;
      transform: unset;
      cursor: pointer;
      &.slick-prev {
        left: 9%;
        transform: rotate(180deg);
        &::before {
          background-image: url('${chevronRightBlack}');
          background-size: 20px 20px;
          display: inline-block;
          width: 20px;
          height: 20px;
          content: '';
        }
        @media (min-width: 414px) {
          left: 5%;
        }
        @media (min-width: 768px) {
          left: 5%;
        }
      }
      &.slick-next {
        right: unset;
        left: 33%;
        &::before {
          background-image: url('${chevronRightBlack}');
          background-size: 20px 20px;
          display: inline-block;
          width: 20px;
          height: 20px;
          content: '';
        }
        @media (min-width: 414px) {
          left: 33%;
        }
        @media (min-width: 768px) {
          left: 18%;
        }
      }
    }
  }
  @media (min-width: 992px) {
    display: none;
  }
`;

export const ImageColumn = styled.div`
  img {
    display: none;
    object-fit: cover;
    max-width: 552px;
    height: 520px;
    transform: translateX(-10%);
    @media (min-width: 992px) {
      display: inline;
    }
  }
  @media (min-width: 992px) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    /* width: 648px; */
    max-height: 528px;
    position: relative;
    z-index: -1;
  }
`;
